var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditImageActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0e0333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.5H12C11.4477 12.5 11 12.9477 11 13.5V28.5C11 29.0523 11.4477 29.5 12 29.5H27C27.5523 29.5 28 29.0523 28 28.5V18",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24L22.6464 21.3536C22.8417 21.1583 23.1583 21.1583 23.3536 21.3536L28 26",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23L14.6464 19.3536C14.8417 19.1583 15.1583 19.1583 15.3536 19.3536L25.5 29.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1464 11.3536L22.5835 15.9165C22.5286 15.9714 22.4872 16.0383 22.4627 16.112L21.8162 18.0513C21.6859 18.4422 22.0578 18.8141 22.4487 18.6838L24.388 18.0373C24.4617 18.0128 24.5286 17.9714 24.5835 17.9165L29.1464 13.3536C29.3417 13.1583 29.3417 12.8417 29.1464 12.6464L27.8536 11.3536C27.6583 11.1583 27.3417 11.1583 27.1464 11.3536Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageActive);
export default __webpack_public_path__ + "static/media/edit-image-active.2eb9497f6df35e1143725de302c41509.svg";
export { ForwardRef as ReactComponent };